import { defineMessages, useIntl } from 'react-intl'
import Heading from 'LuxKit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import type { FiveStarReview } from 'components/Pages/AboutUsPage/Reviews/ReviewCard'
import ReviewCard from 'components/Pages/AboutUsPage/Reviews/ReviewCard'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import { rem } from 'polished'

const reviewMessages = defineMessages({
  vickyContent: {
    id: 'SatWbySsg0OpZ_7KXXAs',
    defaultMessage: 'Love using Luxury Escapes! Always offer fantastic escapes and deliver what is advertised. The service from staff is amazing. Nothing was too much trouble when we recently had to change a booking. Mitchell was very understanding and kept us informed of all our options and went the extra mile to help us. Highly recommend.',
    description: 'Customer review body on the About Us page mentioning Luxury Escapes and staff service',
  },
  gavanContent: {
    id: 'pHeqQulJLwv0x6uVjYiI',
    defaultMessage: 'As a newcomer to Luxury Escapes, I’ve found the whole process really easy and simple. I’ve been able to book awesome accommodation at a great price, and been supported in the most professional and friendly way by Mitchell R when I needed to extend my stay. Everything is sorted as we hoped – and the service we received was fantastic. Thanks Mitchell & the Luxury Escapes team!',
    description: 'Customer review body on the About Us page describing support from Mitchell and Luxury Escapes',
  },
  stracyContent: {
    id: 'ERHEGcil2MzT1e3LsRfe',
    defaultMessage: 'I have booked 2 trips with Luxury Escapes. The first was so amazing that we had to book again! I needed to get some additional information and called. Emily H. was so helpful. She gave me the different options and followed up. I highly recommend booking your next vacation with Luxury Escapes.',
    description: 'Customer review body on the About Us page recommending Luxury Escapes after help from Emily',
  },
  ginaContent: {
    id: '02nrSlrnPsHkhYWGVeTu',
    defaultMessage: 'I’ve used Luxury Escapes on a number of occasions and each time I have called their support team, they have been fantastic. I called the other day with a question about my recent booking for a holiday and Bella M was very helpful and gave me all the information I needed quickly and efficiently. I would recommend Luxury Escapes to anyone who was thinking of a well-priced holiday with excellent customer service.',
    description: 'Customer review body on the About Us page praising Bella and Luxury Escapes customer support',
  },
  susanContent: {
    id: 'PdSxa7jKLxGBcKF32b9N',
    defaultMessage: 'I would recommend Luxury Escapes and will definitely book through them again. The excellent customer service I received from Joseph F with my booking due to a flight change was friendly, knowledgeable, and most importantly, made me feel totally confident in my booking. Best customer service I’ve ever had anywhere, well done Joseph F.',
    description: 'Customer review body on the About Us page praising Joseph and recommending Luxury Escapes',
  },
})

const Container = styled(Pane)`
  padding-bottom: ${rem(48)};
`

interface Props {
  title?: string
}

function Reviews({ title }: Props) {
  const intl = useIntl()
  const reviews: Array<FiveStarReview> = [
    {
      content: intl.formatMessage(reviewMessages.vickyContent),
      name: 'Vicky G',
      source: 'google',
    }, {
      content: intl.formatMessage(reviewMessages.gavanContent),
      name: 'Gavan W.',
      source: 'google',
    }, {
      content: intl.formatMessage(reviewMessages.stracyContent),
      name: 'Stracy A.',
      source: 'google',
    }, {
      content: intl.formatMessage(reviewMessages.ginaContent),
      name: 'Gina T.',
      source: 'google',
    }, {
      content: intl.formatMessage(reviewMessages.susanContent),
      name: 'Susan A.',
      source: 'google',
    },
  ]

  const displayTitle = title ?? intl.formatMessage({
    id: 'iL8KZqvCP9MK8lm0KwDr',
    defaultMessage: 'Hear from our happy customers',
    description: 'About us page - customer reviews section heading on the about us page',
  })

  return (
    <Container>
      <Group direction="vertical" gap={32}>
        <LayoutContainer>
          <Heading variant="heading2">{displayTitle}</Heading>
        </LayoutContainer>
        <FullWidthCarousel snap="start" gap={32} itemsPerArrow={3}>
          {reviews.map((review, index) => (
            <ReviewCard key={index} {...review} />
          ))}
        </FullWidthCarousel>
      </Group>
    </Container>
  )
}

export default Reviews
